import { AccessModes, Dimensions, Metrics, SortOrder, Sources, WITH_ID_SUFFIX } from 'components/insights/constants';

import { BusinessDevelopmentQueryParams } from './query/useBusinessDevelopmentAnalytics';

// --- View By ---

export const VIEW_BY_OPTIONS = [
  { label: 'Referral Source', value: 'referralSource' },
  { label: 'Payer Source', value: 'payerSource' },
] as const;

export const viewByDimension = (viewBy: string): Dimensions =>
  viewBy === 'payerSource' ? Dimensions.HEALTH_PLAN_CLASSIFICATION : Dimensions.TRANSFERRED_FROM_CLIENT;

// --- Table Pivot ---

export const TABLE_PIVOT_OPTIONS = [
  { label: 'Patient Volume', value: 'patientVolume' },
  { label: 'Discharges', value: 'discharges' },
  { label: 'Referrals', value: 'referrals' },
] as const;

// --- Shared Query Params ---
// Care transitions and discharges queries are shared across metric cards, chart, and table.
// Each query runs once; consumers extract what they need (grand total for cards, entity-level for chart/table).

export const buildCareTransitionsParams = (dimension: Dimensions): BusinessDevelopmentQueryParams => ({
  source: Sources.INSIGHTS_CARE_TRANSITIONS,
  accessModes: [AccessModes.MANAGER],
  dimensions: [`${dimension}${WITH_ID_SUFFIX}`],
  metrics: [Metrics.LOCATION_EPISODE_ID_COUNT, Metrics.LENGTH_OF_STAY_AVERAGE],
  sortBy: `${Metrics.LOCATION_EPISODE_ID_COUNT} ${SortOrder.DESC}`,
  rollups: true,
});

export const buildDischargesParams = (dimension: Dimensions): BusinessDevelopmentQueryParams => ({
  source: Sources.LOCATION_EPISODE_DISCHARGES,
  accessModes: [AccessModes.MANAGER],
  dimensions: [`${dimension}${WITH_ID_SUFFIX}`],
  metrics: [Metrics.ID_COUNT, Metrics.READMISSION_RATE],
  sortBy: `${Metrics.ID_COUNT} ${SortOrder.DESC}`,
  rollups: true,
});

export const buildReferralsTableParams = (dimension: Dimensions): BusinessDevelopmentQueryParams => ({
  source: Sources.INSIGHTS_REFERRALS,
  accessModes: [AccessModes.MANAGER],
  dimensions: [`${dimension}${WITH_ID_SUFFIX}`],
  metrics: [
    Metrics.REVIEW_ID_COUNT,
    Metrics.ACCEPTANCE_RATE,
    Metrics.DENIAL_RATE,
    Metrics.CREATED_TO_DISCHARGE_DAYS_AVERAGE,
    Metrics.ACCEPTED_TO_DISCHARGE_DAYS_AVERAGE,
  ],
  sortBy: `${Metrics.REVIEW_ID_COUNT} ${SortOrder.DESC}`,
  rollups: true,
});

// --- Export Params ---

export const buildPatientVolumeExportParams = (dimension: Dimensions): BusinessDevelopmentQueryParams => ({
  source: Sources.INSIGHTS_CARE_TRANSITIONS,
  accessModes: [AccessModes.MANAGER],
  dimensions: [dimension],
  metrics: [Metrics.LOCATION_EPISODE_ID_COUNT, Metrics.LENGTH_OF_STAY_AVERAGE],
});

export const buildDischargesExportParams = (dimension: Dimensions): BusinessDevelopmentQueryParams => ({
  source: Sources.LOCATION_EPISODE_DISCHARGES,
  accessModes: [AccessModes.MANAGER],
  dimensions: [dimension],
  metrics: [Metrics.ID_COUNT, Metrics.READMISSION_RATE],
});

export const buildReferralsExportParams = (dimension: Dimensions): BusinessDevelopmentQueryParams => ({
  source: Sources.INSIGHTS_REFERRALS,
  accessModes: [AccessModes.MANAGER],
  dimensions: [dimension],
  metrics: [
    Metrics.REVIEW_ID_COUNT,
    Metrics.ACCEPTANCE_RATE,
    Metrics.DENIAL_RATE,
    Metrics.CREATED_TO_DISCHARGE_DAYS_AVERAGE,
    Metrics.ACCEPTED_TO_DISCHARGE_DAYS_AVERAGE,
  ],
});
